import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

const selectorsToRemove = [
    '#predictive-search-results'
]

selectorsToRemove.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => el.remove());
})

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    // historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#search",
    contentCssSelector: ".search--alpine",
    dropdownCssSelector:".search-overlay__container",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,
    serpQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "description",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            //     // 'customFields.key', 'customFields.value'
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            // fields: [
            // "productId",
            // "url",
            // "name",
            // "imageUrl",
            // "thumbUrl",
            // "brand",
            // "availability",
            // "price",
            // "priceText",
            // "listPrice",
            // "ratingValue",
            // "reviewCount"
            // ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // Uncomment for Category Merchandisin
    categoryCssSelector: '#main-collection',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
    const input = document.querySelector("#search");
    const formEl = input.closest('form') || null;
    const searchBtn = formEl.querySelector('button[type="submit"]');
    const closeBtn = document.querySelector(".search-overlay__close")

    // const closeSearch = () => {
    //     if(mobileWrapper) {
    //         mobileWrapper.querySelector('[data-search-close]')?.click();
    //         // xBtn.classList.add('inactive');
    //     } else {
    //         document.querySelector('[data-section="header"]')?.click();
    //     }
    //     formEl.reset();
    //     if(document.body.classList.contains('overflow-hidden')) {
    //         document.body.classList.remove('overflow-hidden');
    //     }
    // }

    searchBtn.addEventListener('click', () => {
        closeBtn?.click();
        scrollTo({ top: 0, behavior: 'smooth' });
    })

    input.addEventListener('keyup', (event) => {
        if (event.keyCode === 13 || event.key === 'Enter' || event.key === 'Search') {
            // closeSearch();
            closeBtn?.click();
            scrollTo({ top: 0, behavior: 'smooth' });
        }
    });

    const actBtn = document.querySelector(".ns-act-btn");
    actBtn?.addEventListener('click', () => {
        closeBtn?.click();
        scrollTo({ top: 0, behavior: 'smooth' });
    })

})